<template>
  <v-row>
    <v-col cols="3" align-self="center"> {{ $t('referenceBooks.products.Hopper') }} #{{ hopperNumber }}: </v-col>

    <v-col cols="1" v-if="loading">
      <Loader style="width: 30px; height: 30px" />
    </v-col>

    <v-col cols="6" v-else>
      <v-combobox
        :items="products"
        v-model="selectedProducts"
        multiple
        :item-value="'productId'"
        :item-text="'productName'"
        :key="'productId'"
        :label="$t('referenceBooks.products.ProductsHopper') + ' #' + hopperNumber"
      >
        <template v-slot:prepend-item>
          <v-list-item ripple @click="toggle">
            <v-list-item-action>
              <v-icon>mdi-checkbox-blank-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Select All</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
        <template v-slot:selection="{ item, index }">
          <div style="overflow: auto">
            <v-chip v-if="index < displayCount">
              <span>{{ item["productName"] }}</span>
            </v-chip>
            <span v-else-if="index === displayCount" class="grey--text caption">
              (+{{ selectedProducts.length - index }} others)
            </span>
          </div>
        </template>
      </v-combobox>
    </v-col>
    <v-col v-if="!loading">
      <v-text-field
        :value="hopperInfo.cardsCount"
        :label="$t('referenceBooks.devices.countCards')"
        :disabled="true"
      >
      </v-text-field>
    </v-col>
    <v-col>
      <v-row>
        <div>
          <Promt
            class="mt-3"
            :dialogTitle="$t('referenceBooks.devices.addCards')"
            :textLable="$t('referenceBooks.devices.countCards')"
            :tooltipText="$t('referenceBooks.devices.addCards')"
            v-on:ok="(data) => onAdd(data, 1)"
            :okText="$t('Ok')"
            :cancelText="$t('Cancel')"
            buttonIcon="mdi-plus"
          />
        </div>
        <div>
          <Promt
            class="mt-3"
            :dialogTitle="$t('referenceBooks.devices.removeCards')"
            :textLable="$t('referenceBooks.devices.countCards')"
            :tooltipText="$t('referenceBooks.devices.removeCards')"
            v-on:ok="(data) => onAdd(data, 0)"
            :okText="$t('Ok')"
            :cancelText="$t('Cancel')"
            buttonIcon="mdi-minus"
          />
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Loader from '@/components/Loader';
import Promt from '@/components/Dialogs/Promt';

export default {
  name: 'ProductsInHopperItem',
  props: {
    hopperNumber: {
      type: Number,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAllProducts) {
          this.selectedProducts = [];
        } else {
          this.selectedProducts = this.products.slice();
        }
      });
    },
    onAdd(data, param) {
      this.$axios.hoppers
        .changeCards(
          this.device.deviceId,
          this.hopperNumber,
          param,
          Number(data)
        )
        .then((response) => response.data)
        .then((data) => (this.hopperInfo.cardsCount = data.cardsCount))
        .catch((error) => console.error(error));
    },
  },
  computed: {
    selectedAllProducts() {
      return this.selectedProducts.length === this.products.length;
    },
  },
  async mounted() {
    this.loading = true;
    await this.$axios.products
      .getByDeviceAndHopperNumber(this.device.deviceId, this.hopperNumber)
      .then((response) => response.data)
      .then((json) => (this.selectedProducts = json))
      .catch((error) => console.error(error));

    await this.$axios.hoppers
      .getCountCards(this.device.deviceId, this.hopperNumber)
      .then((response) => response.data)
      .then((json) => {
        if (json === null || json === undefined || json.length === 0) {
          this.hopperInfo = {
            deviceId: this.device.deviceId,
            hepperId: this.hopperNumber,
            cardsCount: 0,
          };
        } else {
          this.hopperInfo = json.find(
            (item) => item.hopperId == this.hopperNumber
          );
        }
      })
      .catch((error) => console.error(error));
    this.loading = false;
  },
  watch: {
    selectedProducts(items) {
      this.$emit('changed', items);
    },
  },
  data() {
    return {
      selectedProducts: [],
      loading: false,
      displayCount: 3,
      hopperInfo: {},
    };
  },
  components: {
    Loader,
    Promt,
  },
};
</script>
